/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
// require('datatables.net')(window, $);
import "datatables.net";

/*------------------------------------*\
    Data Table
\*------------------------------------*/
class DataTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.tableStallions = self.elem.getAttribute('data-table-stallions');
    }

    init() {
        let self = this;

        if(self.tableStallions){
            var table = $('.table').DataTable({
                searching: false,
                lengthChange: false,
                info: false,
                columnDefs: [
                    {
                        render: (data, type, row) => {
                            return data === '0' ? '' : `£${data}`;
                        },
                        targets: 2,
                    },
                ]
            });
        } else {
            var table = $('.table').DataTable({
                searching: false,
                lengthChange: false,
                info: false
            });
        }
    }
}

export default DataTable;
